// extracted by mini-css-extract-plugin
module.exports = {"achievements":"Achievements_achievements__2Q7fJ","achievementList":"Achievements_achievementList__1g_ol","achievement":"Achievements_achievement__AOt_9"};